module.exports = __webpack_public_path__ + "img/9788997798223.f5c7291d.jpg";